<app-header [showAvatar]="false" title="Inbox Template #{{templateId}}" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container body-container-notifications-inbox">
    <div class="page-main">
      <div [formGroup]="form" class="form-wrapper">
        <div class="form-content">
          <div class="form-section">
            <div class="form-section-side">
              <h1 class="label-title">Content</h1>
            </div>
            <div class="form-section-container">
              <div class="form-section-body">
                <div *ngIf="isFormReady" class="form-row">
                  <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
                    <mat-label>Description</mat-label>
                    <textarea id="textArea" matInput formControlName="contentText"></textarea>
                    <mat-error><error-messages [control]="form.get('contentText')"></error-messages></mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Submit Nav -->
        <nav class="post-form size size1of1">
          <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted" ngClass="{'is--loading': formSubmitted}" color="primary" class="custom-mat-button-primary rounded typo uppercase size size1of1">Save Template</button>
        </nav>
      </div>
    </div>
    <div class="page-aside">
      <div class="page-aside-container">
        <div class="form-wrapper">
          <mat-card class="custom-mat-card card-aside">
              <mat-card-header class="card-header">
                <mat-card-title class="label-title">Merge Fields List</mat-card-title>
              </mat-card-header>
              <mat-card-content class="card-content">
                <div class="card-section">
                  <div class="card-row">
                    <p class="typo caption fw400 condensed">Know more about how to use mail merge fields in your email notifications</p>
                  </div>
                </div>
                <div class="card-section">
                  <button mat-flat-button [matMenuTriggerFor]="mergeFields" class="custom-mat-button button-merge-fields size size1of1">Merge Fields <mat-icon svgIcon="ico-dropdown" class="custom-mat-icon ico-size ico-2xs"></mat-icon></button>
                  <mat-menu #mergeFields="matMenu" class="custom-mat-menu-panel">
                    <button mat-menu-item (click)="addField(field)" *ngFor="let field of collectionOfFields; let i = index" [value]="field" class="custom-mat-option" class="custom-mat-menu-item has--no--icon">{{field.name}}</button>
                  </mat-menu>
                </div>
              </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
